module.exports = __webpack_public_path__ + "img/T5-A-rc_1.1d92e03a.png";